import PropTypes from 'prop-types';
import { Grid, Paper, Typography } from '@mui/material';

import ActionButton from '../../../components/ActionButton';
import { STRINGS } from '../../../constants';
import { HELP_SERVICE_TYPES } from '../constants';

export function HelpServiceSelection({
  selectedService,
  onSelectService,
  showSameday,
}) {
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant='h3' sx={{ mb: 1 }}>
        {STRINGS.HELP_SELECT_SERVICE}
      </Typography>
      <Grid container spacing={2} sx={{ mt: 1, alignItems: 'stretch' }}>
        {showSameday ? (
          <Grid size={{ xs: 12, md: 6 }}>
            <ActionButton
              id='help-sameday-service'
              selected={selectedService === HELP_SERVICE_TYPES.SAMEDAY}
              title={STRINGS.HELP_SAMEDAY_SERVICE_TITLE}
              bodyText={STRINGS.HELP_SAMEDAY_SERVICE_BODY}
              additionalInfo={false}
              cardOnclick={() => onSelectService(HELP_SERVICE_TYPES.SAMEDAY)}
            />
          </Grid>
        ) : null}
        <Grid size={{ xs: 12, md: showSameday ? 6 : 12 }}>
          <ActionButton
            id='help-dpd-online-support'
            selected={selectedService === HELP_SERVICE_TYPES.DPD_ONLINE}
            title={STRINGS.HELP_DPD_ONLINE_SUPPORT_TITLE}
            bodyText={STRINGS.HELP_DPD_ONLINE_SUPPORT_BODY}
            additionalInfo={false}
            cardOnclick={() => onSelectService(HELP_SERVICE_TYPES.DPD_ONLINE)}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

HelpServiceSelection.propTypes = {
  selectedService: PropTypes.oneOf([
    HELP_SERVICE_TYPES.SAMEDAY,
    HELP_SERVICE_TYPES.DPD_ONLINE,
    null,
  ]),
  onSelectService: PropTypes.func.isRequired,
  showSameday: PropTypes.bool,
};
